export enum TacticParametersLoading {
  STEPS = 'STEPS_LOADED',
  ADVANCEMENTS = 'ADVANCEMENTS_LOADED',
  TYPES = 'TYPES_LOADED',
}
